export default "__VITE_ASSET__DeBxKtqT__"